<template>
  <div class="text-container">
    <div class="text" v-html="body" />
  </div>
</template>

<script>
  import Slice from 'mixins/slice';

  export default {
    name: 'TextSlice',
    mixins: [Slice]

  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .text-container
    @extend .flex-h
    margin-bottom: 2rem

  .text
    max-width: 800px

  h1
    @extend .t-header
    text-align: center
    margin-bottom: 2rem

  p
    margin-bottom: 1.2rem
    line-height: 1.4rem

  a
    text-decoration: underline

</style>
